<template>
    <li class="select-li hover:!bg-white !px-0 !pb-2 mx-auto group flex gap-2" id="listbox-option-0" role="option">

        <div class="flex items-center justify-between">
            <span class="flex w-[251px] flex-grow flex-col">
                <span class="cb-text-copy-regular font-medium text-gray-900" id="availability-label">{{text}}</span>
            </span>


            <!--enabled-->
            <button @click="active = !active"  type="button" class="toggle-btn " role="switch" aria-checked="false">
                <span class="sr-only">Use setting</span>
                <span aria-hidden="true" class="pointer-events-none absolute h-full w-full rounded-md bg-white"></span>
                <span v-bind:class="[active ? 'enabled' : 'not-enabled']" aria-hidden="true" class="toggle-btn__default "></span>
                <span v-bind:class="[active ? 'enabled' : 'not-enabled']"  aria-hidden="true" class="toggle-switch"></span>
            </button>
        </div>
    </li>
</template>

<script>
    export default {
        name:'SwitchItem',
        props:{
            text: String,
            active: {
                type:Boolean,
                default:false
            }
        },
    }
</script>